module.exports = __webpack_public_path__ + "img/titlevi.4aaf3b16.png";